import { getInvoiceById } from "../services/invoiceService";

/** Read supplier / stock-invoice fields from a medicine inventory batch row. */
export const pickInventorySupplierFields = (batch) => {
  if (!batch || typeof batch !== "object") {
    return { supplierId: null, supplierName: null, stockInvoiceId: null };
  }

  const rawSupplierId =
    batch.supplierId ?? batch.supplier_id ?? batch.supplier?.id ?? null;
  const rawSupplierName =
    batch.supplierName ??
    batch.supplier_name ??
    batch.supplier?.name ??
    batch.supplier?.supplierName ??
    null;
  const rawStockInvoiceId = batch.invoiceId ?? batch.invoice_id ?? null;

  return {
    supplierId:
      rawSupplierId != null && rawSupplierId !== ""
        ? Number(rawSupplierId) || rawSupplierId
        : null,
    supplierName: rawSupplierName ? String(rawSupplierName).trim() : null,
    stockInvoiceId:
      rawStockInvoiceId != null && rawStockInvoiceId !== ""
        ? rawStockInvoiceId
        : null,
  };
};

/**
 * Resolve supplier for an issue (OUT) invoice from inventory batch(es).
 * Prefers supplierId on the inventory row; otherwise loads the stock purchase invoice.
 */
export const resolveSupplierForIssueInvoice = async (batchesOrFields = []) => {
  const list = (Array.isArray(batchesOrFields) ? batchesOrFields : [batchesOrFields])
    .filter(Boolean)
    .map((item) =>
      item.stockInvoiceId != null ||
      item.supplierId != null ||
      item.supplierName != null
        ? {
            supplierId: item.supplierId ?? null,
            supplierName: item.supplierName ?? null,
            stockInvoiceId: item.stockInvoiceId ?? item.invoiceId ?? null,
          }
        : pickInventorySupplierFields(item)
    );

  for (const fields of list) {
    if (fields.supplierId != null) {
      return {
        supplierId: fields.supplierId,
        supplierName: fields.supplierName || null,
      };
    }
  }

  for (const fields of list) {
    if (!fields.stockInvoiceId) continue;
    try {
      const invoice = await getInvoiceById(fields.stockInvoiceId);
      const supplierId =
        invoice?.supplierId ??
        invoice?.supplier_id ??
        invoice?.supplier?.id ??
        null;
      if (supplierId != null && supplierId !== "") {
        return {
          supplierId: Number(supplierId) || supplierId,
          supplierName:
            invoice?.supplierName ||
            invoice?.supplier_name ||
            invoice?.supplier?.name ||
            fields.supplierName ||
            null,
        };
      }
    } catch (error) {
      console.warn(
        `[resolveSupplierForIssueInvoice] Could not load stock invoice ${fields.stockInvoiceId}:`,
        error
      );
    }
  }

  return { supplierId: null, supplierName: null };
};
